import React from 'react';
import { AE_ICON_BTN, AE_ICON_BTN_DANGER, AE_ICON_BTN_PRIMARY, AE_ICON_BTN_SUCCESS, AE_ICON_BTN_WARNING } from './aeTheme';

type AeIconButtonVariant = 'default' | 'primary' | 'success' | 'warning' | 'danger';

interface AeIconButtonProps {
  label: string;
  onClick?: () => void;
  disabled?: boolean;
  variant?: AeIconButtonVariant;
  /** Dense 32px square for list rows. */
  compact?: boolean;
  children: React.ReactNode;
  /** Render as Link-style anchor when href is set. */
  href?: string;
}

const variantClass: Record<AeIconButtonVariant, string> = {
  default: AE_ICON_BTN,
  primary: AE_ICON_BTN_PRIMARY,
  success: AE_ICON_BTN_SUCCESS,
  warning: AE_ICON_BTN_WARNING,
  danger: AE_ICON_BTN_DANGER,
};

/** Accessible icon-only button for AE list rows and headers. */
export const AeIconButton: React.FC<AeIconButtonProps> = ({
  label,
  onClick,
  disabled,
  variant = 'default',
  compact = false,
  children,
  href,
}) => {
  const className = `${variantClass[variant]}${compact ? ' !h-8 !w-8 !p-1 shrink-0 box-border' : ''}`;

  if (href) {
    return (
      <a href={href} className={className} title={label} aria-label={label}>
        {children}
      </a>
    );
  }

  return (
    <button
      type="button"
      className={className}
      onClick={onClick}
      disabled={disabled}
      title={label}
      aria-label={label}
    >
      {children}
    </button>
  );
};
